import DOMPurify from 'dompurify';

/**
 * Safely creates markup from HTML string by sanitizing it to prevent XSS attacks
 * @param {string} html - Raw HTML string to sanitize
 * @returns {object} Object with __html property for use with dangerouslySetInnerHTML
 */
export default html => {
  if (!html) return { __html: '' };

  // Sanitize HTML to prevent XSS attacks
  const cleanHtml = DOMPurify.sanitize(html, {
    ALLOWED_TAGS: [
      'b',
      'i',
      'em',
      'strong',
      'u',
      'p',
      'br',
      'span',
      'div',
      'a',
      'ul',
      'ol',
      'li',
      'h1',
      'h2',
      'h3',
      'h4',
      'h5',
      'h6',
      'code',
      'pre'
    ],
    ALLOWED_ATTR: ['href', 'target', 'rel', 'class', 'id']
  });

  return { __html: cleanHtml };
};
